const routes = [{
	path: "/Admin/Invoicing",
	component: () => import(/* webpackChunkName: "Invoicing" */ "./Index.vue")
},
{
	path: "/Admin/Invoicing/BookingsToInvoice",
	component: () => import(/* webpackChunkName: "Invoicing" */ "./BookingsToInvoice.vue")
}];
export default routes;
